import { Box, Divider, Flex, Image, SimpleGrid, Text, Link, Icon } from "@chakra-ui/react";
import React from "react";
import { motion } from "framer-motion";
import { FiExternalLink, FiArrowRight } from "react-icons/fi";
import Flashride from "../assets/flashride.jpg";
import Connect from "../assets/connect.jpg";
import Jomav from "../assets/jomav.jpg";
import Vendcliq from "../assets/vendcliq.png";
import Willis from "../assets/willis.png";
import Sabi from "../assets/sabi.png";
import Pykup from "../assets/pykup.png";
import Branching from "../assets/branching.png";
import RealObafunso from "../assets/Screenshot 2025-08-25 at 11.24.23.png";

const MotionBox = motion(Box);

export const Projects = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  };

  const ProjectComponent = ({ image, title, description, address }) => {
    return (
      <MotionBox
        variants={item}
        whileHover={{ y: -10 }}
        transition={{ type: "spring", stiffness: 300 }}
        w="full"
        bg="rgba(255, 255, 255, 0.03)"
        borderRadius="2xl"
        overflow="hidden"
        border="1px solid"
        borderColor="whiteAlpha.100"
        backdropFilter="blur(10px)"
        boxShadow="xl"
        role="group"
        position="relative"
      >
        <Link href={address} isExternal _hover={{ textDecoration: "none" }}>
          <Box position="relative" overflow="hidden" h="250px">
            <Box
              h="100%"
              transition="transform 0.5s ease"
              _groupHover={{ transform: "scale(1.05)" }}
            >
              {/* Ensure image fills the container */}
              <Flex h="100%" w="100%" overflow="hidden" align="center" justify="center" bg="gray.800">
                  {React.cloneElement(image, { objectFit: "cover", width: "100%", height: "100%" })}
              </Flex>
            </Box>
            
            {/* Overlay on hover */}
            <Flex
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bg="blackAlpha.600"
              opacity={0}
              _groupHover={{ opacity: 1 }}
              transition="all 0.3s"
              justify="center"
              align="center"
            >
              <Flex 
                align="center" 
                gap="2" 
                color="white" 
                fontWeight="bold" 
                fontSize="lg"
                transform="translateY(20px)"
                _groupHover={{ transform: "translateY(0)" }}
                transition="transform 0.3s delay 0.1s"
              >
                View Project <Icon as={FiExternalLink} />
              </Flex>
            </Flex>
          </Box>

          <Box p="6">
            <Flex justify="space-between" align="center" mb="2">
              <Text
                fontSize="2xl"
                fontWeight="bold"
                color="white"
                letterSpacing="tight"
                _groupHover={{ color: "#F0451A" }}
                transition="color 0.2s"
              >
                {title}
              </Text>
            </Flex>
            <Text color="gray.400" fontSize="sm" lineHeight="tall" noOfLines={3}>
              {description}
            </Text>
            
            <Flex align="center" mt="4" color="#F0451A" fontSize="sm" fontWeight="medium">
              <Text mr="2">Explore</Text>
              <Icon as={FiArrowRight} transition="transform 0.2s" _groupHover={{ transform: "translateX(5px)" }} />
            </Flex>
          </Box>
        </Link>
      </MotionBox>
    );
  };

  return (
    <Box bg={"#17181A"} id="project" position="relative" overflow="hidden">
      {/* Decorative background blur */}
      <Box
        position="absolute"
        top="-20%"
        right="-10%"
        width="600px"
        height="600px"
        bg="#F0451A"
        opacity="0.05"
        filter="blur(100px)"
        borderRadius="full"
        zIndex={0}
      />

      <Box py="24" px={{ base: "6", md: "12", lg: "24" }} position="relative" zIndex={1}>
        <Flex flexDirection={"column"} mb="12">
          <Box>
            <Text
              fontSize={{ base: "4xl", md: "6xl" }}
              color="white"
              fontWeight="bold"
              lineHeight="shorter"
              mb="4"
            >
              Selected <Text as="span" color="#F0451A">Works</Text>
            </Text>
            <Divider border="2px solid #F0451A" width={"20"} mb="6" borderRadius="full" />
            <Text color="gray.400" maxW="2xl" fontSize="lg">
              Here are some of the projects I've worked on. Each one represents a unique challenge and a tailored solution.
            </Text>
          </Box>
        </Flex>
        
        <Box
          as={motion.div}
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.1 }}
        >
          <SimpleGrid
            columns={{ base: 1, md: 2, lg: 3 }}
            spacing={{ base: "8", md: "10" }}
          >
            <ProjectComponent
              title={"Shipping"}
              address={"https://shipping-teal-rho.vercel.app/"}
              description={""}
              image={<Image src={Sabi} alt="Just Sabi" />}
            />
            <ProjectComponent
              title={"Willis University"}
              address={"https://willlis-edu.vercel.app/"}
              description={"Streamlining global logistics with cutting-edge technology and reliable shipping solutions. Ready to move your business forward."}
              image={<Image src={Willis} alt="Willis University" />}
            />
          
            <ProjectComponent
              title={"Pykup"}
              address={"https://pykup-website-gray.vercel.app/"}
              description={"A Logistics company website offering streamlined package tracking and delivery services."}
              image={<Image src={Pykup} alt="Pykup" />}
            />
            <ProjectComponent
              title={"Branching"}
              address={"https://branching-client.vercel.app/dashboard"}
              description={
                "A robust B2B platform empowering businesses to effortlessly manage their inventory, orders, and logistics."
              }
              image={<Image src={Branching} alt="Branching" />}
            />
          
           
          
            <ProjectComponent
              title={"Jomav Homes"}
              address={"https://jomav-website.vercel.app/"}
              description={"A real estate company software showcasing properties and streamlining client interactions."}
              image={<Image src={Jomav} alt="Jomav Homes" />}
            />
                  <ProjectComponent
              title={"Connect Hub"}
              address={"https://connect-hub-ten.vercel.app/"}
              description={"A vibrant tech community website fostering connection, learning, and collaboration."}
              image={<Image src={Connect} alt="Connect Hub" />}
            />
                  <ProjectComponent
              title={"Vendcliq"}
              address={"https://app.vendcliq.com/"}
              description={"A loan application specifically designed to support the growth of small businesses."}
              image={<Image src={Vendcliq} alt="Vendcliq" />}
            />
                 <ProjectComponent
              title={"Flashride"}
              address={"https://flashride.ng/"}
              description={"A modern logistics company website focusing on speed and reliability for urban deliveries."}
              image={<Image src={Flashride} alt="Flashride" />}
            />
                  <ProjectComponent
              title={"Real Obafunso Lounge"}
              address={"https://realobafunsolounge.vercel.app/"}
              description={"An elegant digital menu and reservation system for a premium lounge experience."}
              image={<Image src={RealObafunso} alt="Real Obafunso Lounge" />}
            />
          </SimpleGrid>
        </Box>
      </Box>
    </Box>
  );
};
